module.exports = __webpack_public_path__ + "static/media/Item 7.ad5a6292.jpg";